import { getHostName } from 'app/utils';
import { HOST_NAMES } from 'app/utils/constants';

const CommonDetectionImageResolutions = {
  64: {
    name: '64',
    value: 64,
  },
  128: {
    name: '128',
    value: 128,
  },
  256: {
    name: '256',
    value: 256,
  },
  320: {
    name: '320',
    value: 320,
  },
  480: {
    name: '480',
    value: 480,
  },
  576: {
    name: '576',
    value: 576,
  },
  640: {
    name: '640',
    value: 640,
  },
  768: {
    name: '768',
    value: 768,
  },
  1024: {
    name: '1024',
    value: 1024,
  },
  1280: {
    name: '1280',
    value: 1280,
  },
  1536: {
    name: '1536',
    value: 1536,
  },
  1920: {
    name: '1920',
    value: 1920,
  },
  2560: {
    name: '2560',
    value: 2560,
  },
  3200: {
    name: '3200',
    value: 3200,
  },
  3840: {
    name: '3840',
    value: 3840,
  },
  4096: {
    name: '4096',
    value: 4096,
  },
  0: {
    name: 'Custom',
    value: 0,
  },
};

const DetectionImageResolutions = {
  vit: { ...CommonDetectionImageResolutions },
  cnn: { ...CommonDetectionImageResolutions },
};

const ClassificationImageResolutions = {
  vit: {
    224: {
      name: '224',
      value: 224,
    },
    448: {
      name: '448',
      value: 448,
    },
    518: {
      name: '518',
      value: 518,
    },
    560: {
      name: '560',
      value: 560,
    },
    0: {
      name: 'Custom',
      value: 0,
    },
  },
  cnn: {
    64: {
      name: '64',
      value: 64,
    },
    128: {
      name: '128',
      value: 128,
    },
    256: {
      name: '256',
      value: 256,
    },
    320: {
      name: '320',
      value: 320,
    },
    480: {
      name: '480',
      value: 480,
    },
    576: {
      name: '576',
      value: 576,
    },
    0: {
      name: 'Custom',
      value: 0,
    },
  },
};

const getCNNTrainingDefaultConfigs = () => {
  const hostName = getHostName();

  switch (hostName) {
    case HOST_NAMES.GF7NONPROD:
    case HOST_NAMES.GF7PROD:
      return {
        epochs: 30,
        imageResolution: 480,
        dataPercentages: { training: 80, validation: 10, test: 10 },
      };
    default:
      return {
        epochs: 30,
        imageResolution: 256,
        dataPercentages: { training: 80, validation: 10, test: 10 },
      };
  }
};

const getVITTrainingDefaultConfigs = () => {
  const hostName = getHostName();

  switch (hostName) {
    case HOST_NAMES.TOWERSEMI:
      return {
        epochs: 30,
        imageResolution: 672,
        dataPercentages: { training: 75, validation: 20, test: 5 },
      };
    default:
      return {
        epochs: 15,
        imageResolution: 518,
        dataPercentages: { training: 80, validation: 10, test: 10 },
      };
  }
};

const DefaultTrainingConfigs = {
  cnn: getCNNTrainingDefaultConfigs,
  vit: getVITTrainingDefaultConfigs,
};

export {
  ClassificationImageResolutions,
  DefaultTrainingConfigs,
  DetectionImageResolutions,
};
